import track from '../../../../../shared/util/utilities/mixpanel';
import { useField } from 'react-final-form';
import { SendElectronicInvoiceMethod } from '../book-and-send/types';

export function bookAndSendTracker(action: string, trackingData?: object) {
    track('defaulteinvoice', action, trackingData);
}

export function splitEmails(value: string) {
    return (value || '')
        .split(' ')
        .map(m => m.trim())
        .filter(m => !!m);
}

export function useEmailOptionsPdfSelected(): boolean {
    const {
        input: { value: emailOptions },
    } = useField<{
        includePdfLink: boolean;
        includePdfAsAttachment: boolean;
    }>('emailOptions');

    const isPdfOptionSelected = emailOptions.includePdfLink || emailOptions.includePdfAsAttachment;

    return isPdfOptionSelected;
}

export function useEmailOptionsOioSelected(): boolean {
    const {
        input: { value: emailOptions },
    } = useField<{
        includeOioLink: boolean;
        includeOioAsAttachment: boolean;
    }>('emailOptions');

    const isOioOptionSelected = emailOptions.includeOioLink || emailOptions.includeOioAsAttachment;

    return isOioOptionSelected;
}

export function useEmailOptionsRecipientsSelected(): boolean {
    const {
        input: { value: emailOptions },
    } = useField<{
        recipients: string;
        recipientsCc: string;
        recipientsBcc: string;
    }>('emailOptions');

    return !!emailOptions.recipients || !!emailOptions.recipientsCc || !!emailOptions.recipientsBcc;
}

export function useEInvoiceOptionsCorrectGlnNumber(): boolean {
    const {
        input: { value: eInvoiceOptions },
    } = useField<{
        gln: string;
        sendingMethod: SendElectronicInvoiceMethod;
    }>('eInvoiceOptions');

    return eInvoiceOptions.sendingMethod === SendElectronicInvoiceMethod.GlnNumber ? !!eInvoiceOptions.gln : true;
}

export function useEInvoiceOptionsCorrectCvrNumber(): boolean {
    const {
        input: { value: eInvoiceOptions },
    } = useField<{
        cvr: string;
        sendingMethod: SendElectronicInvoiceMethod;
    }>('eInvoiceOptions');

    return eInvoiceOptions.sendingMethod === SendElectronicInvoiceMethod.CvrNumber ? !!eInvoiceOptions.cvr : true;
}

export function useEInvoiceOptionsCorrectPNumber(): boolean {
    const {
        input: { value: eInvoiceOptions },
    } = useField<{
        pNumber: string;
        sendingMethod: SendElectronicInvoiceMethod;
    }>('eInvoiceOptions');

    return eInvoiceOptions.sendingMethod === SendElectronicInvoiceMethod.PNumber ? !!eInvoiceOptions.pNumber : true;
}

export function useEInvoiceOptionsContactSelected(): boolean {
    const {
        input: { value: eInvoiceOptions },
    } = useField<{
        yourRef: string;
        attentionRef: string;
        sendingMethod: SendElectronicInvoiceMethod;
    }>('eInvoiceOptions');

    return eInvoiceOptions.sendingMethod === SendElectronicInvoiceMethod.GlnNumber
        ? !!eInvoiceOptions.yourRef || !!eInvoiceOptions.attentionRef
        : true;
}

export const legacyForms = {
    quotations: '1',
    orders: '2',
    customers: '4',
    customerProjects: '71',
    archive: '104',
};
